import { Mixpanel } from "./Mixpanel";

export class MixpanelPricing {
  static pricingOpen({ placement }: { placement: string }) {
    Mixpanel.track("Pricing - Open", {
      placement,
    });
  }

  static requestQuote() {
    Mixpanel.track("Pricing - Request Quote", {});
  }

  static buySubscription({
    subscriptionType,
    subscriptionPeriod,
    amount,
  }: {
    subscriptionType: string;
    subscriptionPeriod: string;
    amount: number;
  }) {
    Mixpanel.track("Pricing - Buy Subscription", {
      subscriptionType,
      subscriptionPeriod,
      amount,
    });
  }
}
